exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".customize-option .scrollview-list{box-shadow:none;border-bottom:1px solid #e0e0e0;border-radius:0;margin:15px}.customize-option .scrollview-list .scrollview-list-item{padding-bottom:15px;margin-left:20px;display:flex;font-size:16px}.customize-option .scrollview-list small svg{margin-right:15px;fill:#4f4f4f}.customize-option .scrollview-list li{display:flex;justify-content:space-between;width:100%}.customize-option .scrollview-list li svg{margin-bottom:-3px;margin-right:5px}.customize-option .customize-update-btn{text-align:center}.customize-option .customize-update-btn button{margin:40px 16px 0;min-width:70%}@media screen and (max-width: 767px){#preferences-selection-component .customize-update-btn{position:fixed;width:100vw;left:0;bottom:calc(65px + env(safe-area-inset-bottom, 0))}#preferences-selection-component .card-container{box-shadow:none !important;padding:0 !important;margin-bottom:50px}#preferences-selection-component .card-container ul.scrollview-list.collapsable-list{margin:0;padding:15px}#preferences-selection-component .card-component{margin:0 !important}#preferences-selection-component .subscribe-card-container{margin:5px !important;margin-bottom:20px !important}#preferences-selection-component .card-component .card-container{box-shadow:0px 0px 10px 5px rgba(51,51,51,.1) !important}}", ""]);

// Exports
exports.locals = {
	"colorTeal": "#54c2b6",
	"colorViolet": "#727cf5",
	"colorTealRedChannel": "84",
	"colorTealGreenChannel": "194",
	"colorTealBlueChannel": "182",
	"colorTealDark": "#26a995",
	"colorTeal50": "rgba(84,194,182,.5)",
	"colorTealScreened": "#54c2b6",
	"colorWhiteOff": "#f2f2f2",
	"colorWhite": "#fff",
	"colorWhiteTrans": "rgba(255,255,255,0)",
	"colorWhite50": "rgba(255,255,255,.5)",
	"colorWarning": "#ea3030",
	"colorWarningLight": "rgba(234,48,48,.15)",
	"colorBlack": "#333",
	"colorGrayDark": "#4f4f4f",
	"colorGray": "#828282",
	"colorGrayLight": "#e0e0e0",
	"colorGrayLight60": "rgba(224,224,224,.6)",
	"colorBlue": "#049fda",
	"colorBlackDark": "#242424",
	"ColorText": "#474747",
	"colorBlueScreened": "#049fda",
	"colorMagenta": "#ea3b7d",
	"colorMagentaScreened": "#ea3b7d",
	"colorYellow": "#fed504",
	"colorYellowDark": "#d8b129",
	"colorYellowScreened": "#fed504",
	"colorUi1": "rgba(4,159,218,.3)",
	"colorUi2": "rgba(84,194,182,.3)",
	"colorUi3": "rgba(234,59,125,.3)",
	"colorUi4": "rgba(254,213,4,.3)",
	"colorUi5": "rgba(31,79,228,.3)",
	"colorUi6": "rgba(177,208,21,.3)",
	"colorUi7": "rgba(228,34,255,.3)",
	"colorUi8": "rgba(255,157,39,.3)",
	"colorUi9": "rgba(66,32,208,.3)",
	"colorUi10": "rgba(26,255,198,.3)",
	"colorUi11": "rgba(205,38,26,.3)",
	"colorUi12": "rgba(247,184,50,.3)",
	"colorUi13": "rgba(146,79,207,.3)",
	"colorUi14": "rgba(98,205,36,.3)",
	"colorUi15": "rgba(255,24,9,.3)",
	"colorUi16": "rgba(207,111,79,.3)",
	"chartLightYellow": "rgba(252,215,34,.7)",
	"chartLightPink": "rgba(250,92,124,.7)",
	"chartLightBlue": "rgba(57,175,209,.7)",
	"fontStyleNormal": "\"robotoregular\",sans-serif"
};